<template>
	<div id="loader" class="h-100 p-0 d-flex flex-column justify-content-center align-items-center">
		<div>
			<h1>Por favor espera. Tu sesión se está cargando...</h1>
		</div>
		<div>
			<img src="@/assets/css/icons/loader.svg" alt="Loading Content">
		</div>
		<div v-if="audio.downloading">
			<div>
				<h1>Cargando medios</h1>
			</div>
			<div class="progress">
				<div class="progress-bar" role="progressbar" :style="`width: ${Math.round((audio.loaded/audio.size) * 100 ) + '%'}`" :aria-valuenow="Math.round((audio.loaded/audio.size) * 100 )" aria-valuemin="0" aria-valuemax="100">{{ Math.round((audio.loaded/audio.size) * 100 ) + '%' }}</div>
			</div>
		</div>
	</div>

</template>

<script>
import { useStore } from "vuex";

export default {
	name: "Loader",
	setup(){
		const store = useStore();
		return {
			audio: store.getters.audio
		}
	}
}
</script>

<style scoped>
	#loader h1{
		color:var(--color-navy-blue);
		font-size:16px;
		letter-spacing:1px;
		font-weight:200;
		text-align:center;
	}
	#loader i{
		font-size: 50px;
		color: #3ccfcf;
	}
	.progress{
		width: 200px;
	}
</style>